import { useCallback } from "react";
import { matchPath, useLocation } from "react-router";
import { APP_URL } from "./../../../utils/defines";
import { EtudeStep } from "utils/defines";

export const useMatchEtudePath = () => {
  const { pathname } = useLocation();

  const matchEtudePath = useCallback(
    (step: EtudeStep, strict?: boolean) => {
      let url = "";
      switch (step) {
        case EtudeStep.Solutions:
          url = APP_URL.Solutions;
          break;
        case EtudeStep.SolutionDetails:
          url = APP_URL.SolutionDetails;
          break;
        case EtudeStep.Accessoires:
          url = APP_URL.SolutionDetailAccesories;
          break;
        case EtudeStep.Documents:
          url = APP_URL.SolutionDetailDocuments;
          break;
      }
      return (
        matchPath(
          {
            path: `${APP_URL.Base}/${APP_URL.Etude}/${url}`,
            end: false,
          },
          pathname
        ) ||
        (!strict &&
          matchPath(
            {
              path: `${APP_URL.Base}/${APP_URL.Etude}/${APP_URL.SolutionDetailDocuments}`,
              end: false,
            },
            pathname
          ))
      );
    },
    [pathname]
  );

  return { matchEtudePath };
};
